import { render, staticRenderFns } from "./HistoryButtons.vue?vue&type=template&id=bc413c18&"
import script from "./HistoryButtons.vue?vue&type=script&lang=js&"
export * from "./HistoryButtons.vue?vue&type=script&lang=js&"
import style0 from "./HistoryButtons.vue?vue&type=style&index=0&id=bc413c18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports